import React from 'react';
import Component from '@/Component';

export default class Donation extends Component {

  componentDidMount() {
    this.props._getNotice();
  }

  render() {
    return (
      <div></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Background.js